




































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { tagWebservice } from '@/webservices/tag';
import type { Tag } from '@/models/tag';
import type { User } from '@/models/user';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'TagList',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {},
})
export default class TagList extends Vue {
    private tags = new Array<Tag>();

    private tableSettings = {
        openedDetailed: Array<number>(),
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };
    @Getter('account/userInfo') private userInfo: User;

    private mounted() {
        this.load();
    }

    private load() {
        tagWebservice
            .load()
            .then((response) => {
                this.tags = response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    }
}
